import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiEyeSlashBold, PiSealCheck, PiEyeBold } from 'react-icons/pi';
import { NOTIFICATION_STATUS } from 'services/notifications/types/enums';
import { IColorProp } from 'types/components/components.interface';

export interface ILabeledStatusProps {
  status: NOTIFICATION_STATUS ;
}

interface ILabeledStatusParams extends IColorProp {
  status: NOTIFICATION_STATUS ;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledStatusParams[] = [
  {
    status: NOTIFICATION_STATUS.NotDisplayed,
    color: 'red',
    icon: <PiEyeSlashBold />,
  },
  {
    status: NOTIFICATION_STATUS.Displayed ,
    color: 'blue',
    icon: <PiEyeBold />,
  },
  {
    status: NOTIFICATION_STATUS.Done,
    color: 'green',
    icon: <PiSealCheck />,
  },
];

const LabelNotificationStatus = ({ status }: ILabeledStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ??
    labeledStatusParams[0];
  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(`enum.NOTIFICATION_STATUS.${NOTIFICATION_STATUS[labeledParams.status]}`)}>
      {labeledParams.icon}{' '}
      {t(`enum.NOTIFICATION_STATUS.${NOTIFICATION_STATUS[labeledParams.status]}`)}
    </Label>
  );
};

export default LabelNotificationStatus;
